/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { formatNumber, formatNumberWithComma } from '../../../utilities/formatHelpers';
import { currencies, exchange } from '../../../utilities/constants';
import { MODAL_SCREENS } from '../constants';

const DepositedItemLayout = ({ item, showScreen, onDetailsClick }) => {
  const { t: translate } = useTranslation();

  const handleOnClick = () => {
    showScreen(MODAL_SCREENS.DEPOSIT_DETAILS);
    onDetailsClick(item);
  };

  const details = (
    <button
      type="button"
      className="btn yield-btn text-f6 py-2 px-3 border-0 text-f5 text-bolder"
      onClick={handleOnClick}>
      <b>{translate('details_button_title')}</b>
    </button>
  );

  return (
    <div
      className="row bg-lighter rounded-extra px-md-4 px-3  py-3 my-3 mx-0"
      role="button"
      onClick={handleOnClick}
      onKeyDown={handleOnClick}
      tabIndex={-1}>
      <div className="col-md-3 col my-auto text-f4 text-bolder">{`${formatNumber(
        item?.annualizedYield,
        exchange.FIAT_VALUE
      )}%`}</div>
      <div className="col-2 ps-0 d-md-block d-none my-auto text-f5 text-bolder">
        {translate('yield_offer_details_modal_days_label').replace(
          '__DAYS_NUMBER__',
          item?.duration
        )}
      </div>
      <div className="col-3 d-md-block d-none text-nowrap my-auto text-f5 text-bolder">{`${formatNumberWithComma(
        formatNumber(item?.settleCoinEffectivePurchasePrice, exchange.FIAT_VALUE)
      )} ${currencies.USDC.fullName}`}</div>
      <div className="col-3 ps-4 d-md-block d-none text-nowrap my-auto text-f5 text-bolder">{`${formatNumberWithComma(
        formatNumber(item?.depositedAmount, exchange.FIAT_VALUE)
      )} ${currencies.USDC.fullName}`}</div>
      <div className="col-1 d-md-block d-none text-end my-auto pe-0">{details}</div>
      <div className="d-md-none d-block col-6 p-0">
        <div className="d-flex flex-column align-items-end ">
          <p>{`${formatNumberWithComma(formatNumber(item?.linkedPrice, exchange.FIAT_VALUE))} ${
            currencies.USDC.fullName
          }`}</p>
          <p className="text-shadow text-f5">
            {moment(item?.expirationDate, 'YYYYMMDDh:mm:ss').format('DD/MM/YYYY')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default DepositedItemLayout;

DepositedItemLayout.propTypes = {
  item: PropTypes.object.isRequired,
  onDetailsClick: PropTypes.func.isRequired,
  showScreen: PropTypes.func.isRequired,
};
